export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_27-0b8b8604eab9cc88fcc9e505ee3cfe93.jpg";